export default {
    install (Vue) {
        Vue.prototype.$zendeskChat = {
            hide () {
                try {
                    window.zEmbed(() => {
                        window.zEmbed.hide()
                    })
                } catch (err) {
                    console.error('Failed to hide Zendesk Chat widget.')
                }
            },

            show () {
                try {
                    window.zEmbed(() => {
                        window.zEmbed.show()
                    })
                } catch (err) {
                    console.error('Failed to show Zendesk Chat widget.')
                }
            }
        }
    }
}
